// Layer 3 (Transformation): signal reliability labels and diagnosis weights (tarp.A7).

import type { SignalCadence, SignalReliability, SignalRole } from '@/versions/v1/schema/tag-mapping';
import type { DiagnosticRule } from '@/versions/v1/schema/diagnostic-rule';
import { TAG_MAPPING } from '@/versions/v1/shared/bunker-hill-spc';

const MAPPING_BY_ROLE = new Map(TAG_MAPPING.map((row) => [row.role, row]));

export const RELIABILITY_WEIGHT: Record<SignalReliability, number> = {
  'online-high': 1.0,
  'manual-medium': 0.7,
  'manual-low': 0.5,
};

export function reliabilityWeightForRole(role: SignalRole): number {
  const mapping = MAPPING_BY_ROLE.get(role);
  if (!mapping) return 1;
  return RELIABILITY_WEIGHT[mapping.reliability];
}

export function reliabilityPillLabel(reliability: SignalReliability): string {
  switch (reliability) {
    case 'online-high':
      return 'online · high';
    case 'manual-medium':
      return 'manual · medium';
    case 'manual-low':
      return 'manual · low';
  }
}

export function cadencePillLabel(cadence: SignalCadence): string {
  return cadence;
}

export type ClauseWeightLine = {
  label: string;
  factor: number;
};

/** Per-clause reliability factors for rule-card tooltips. */
export function clauseWeightLines(rule: DiagnosticRule): readonly ClauseWeightLine[] {
  const lines: ClauseWeightLine[] = [];
  if (rule.when) {
    for (const clause of rule.when) {
      lines.push({
        label: clause.label,
        factor: reliabilityWeightForRole(clause.signal),
      });
    }
  }
  return lines;
}
